import React from "react"

const QuickQuoteLogContext = React.createContext({})

const { Provider, Consumer } = QuickQuoteLogContext

export { Provider, Consumer, QuickQuoteLogContext }
